export default "__VITE_ASSET__CQ$u6n_J__"